module.exports = __webpack_public_path__ + "icon-framework-rxjs.3TBFWoSS.svg";